import { Decorators, EntityGrid, ToolButton } from "@serenity-is/corelib";
import { indexOf } from "@serenity-is/corelib";
import { EmailQueueDialog } from "./EmailQueueDialog";
import { EmailQueueRow, EmailQueueColumns, EmailQueueService } from "../ServerTypes/Pro";

@Decorators.registerClass('Serenity.Pro.EmailQueue.EmailQueueGrid')
export class EmailQueueGrid<P = {}> extends EntityGrid<EmailQueueRow, P> {
    protected getColumnsKey() { return EmailQueueColumns.columnsKey; }
    protected getDialogType() { return EmailQueueDialog; }
    protected getRowDefinition() { return EmailQueueRow; }
    protected getService() { return EmailQueueService.baseUrl; }

    protected getButtons(): ToolButton[] {
        var buttons = super.getButtons();
        buttons.splice(indexOf(buttons, x => x.action === "add"), 1);
        return buttons;
    }
}